<div class="panel-heading" role="tab" id="heading_assessments">
  <div class="row">
    <div class="col-md-6">
      <h4 class="panel-title">
        <a role="button" id="collapse_assessments" data-toggle="collapse" data-parent="#accordion" href="#panel_assessments" aria-expanded="true" aria-controls="collapse_assessments">
          Assessments
        </a>
      </h4>
    </div>
  </div>
</div>
<div id="panel_assessments" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="heading_assessments">
  <div class="panel-body">
    <table class="table table-bordered table-striped table-condensed">
      <tr>
        <th>Assessment Slug</th>
        <th>Passed</th>
        <th></th>
      </tr>
      {{#each assessments}}
        <tr>
          <td>{{slug}}</td>
          <td>{{passed}}</td>
          <td>
            {{#if progress}}
              <button class="btn btn-xs btn-assess btn-danger" data-slug="{{slug}}" data-module="{{moduleKey}}">Remove</button>
            {{else}}
              <button class="btn btn-xs btn-assess btn-success" data-slug="{{slug}}" data-module="{{moduleKey}}" data-pass="true">Pass</button>
              <button class="btn btn-xs btn-assess btn-success" data-slug="{{slug}}" data-module="{{moduleKey}}">Fail</button>
            {{/if}}
          </td>
        </tr>
      {{/each}}
    </table>
  </div>
</div>
